/**
 * Utility functions for masking sensitive data
 */

/**
 * Mask engine number: Show first 3 characters, mask the rest with asterisks
 * @param {string|number|null|undefined} value - The engine number to mask
 * @returns {string} - Masked value (e.g., "ABC***")
 */
export function maskEngineChassisNumber(value) {
  if (value === null || value === undefined) {
    return '';
  }
  const stringValue = typeof value === 'string' ? value : String(value);
  if (!stringValue || stringValue.trim() === '') {
    return '';
  }
  const trimmed = stringValue.trim();
  if (trimmed.length <= 3) {
    return trimmed;
  }
  const firstThree = trimmed.substring(0, 3);
  const maskedPart = '*'.repeat(Math.max(0, trimmed.length - 3));
  return firstThree + maskedPart;
}

/**
 * Mask chassis number for display only: Show first 4 characters, mask the rest with asterisks.
 * Use for UI display to prevent misuse; full value must be used for save/transmit.
 * @param {string|number|null|undefined} value - The chassis number to mask
 * @returns {string} - Masked value (e.g., "ABCD************")
 */
export function maskChassisNumber(value) {
  if (value === null || value === undefined) {
    return '';
  }
  const stringValue = typeof value === 'string' ? value : String(value);
  if (!stringValue || stringValue.trim() === '') {
    return '';
  }
  const trimmed = stringValue.trim();
  if (trimmed.length <= 4) {
    return trimmed;
  }
  const firstFour = trimmed.substring(0, 4);
  const maskedPart = '*'.repeat(Math.max(0, trimmed.length - 4));
  return firstFour + maskedPart;
}